const validate = values => {
  const errors = {};
  if (!values.property) {
    errors.property = 'You must select a property';
  }
  if (!values.transaction_type) {
    errors.transaction_type = 'You must select a transaction type';
  }
  if (!values.transactions || !values.transactions.length) {
    errors.transactions = { _error: 'You must add at least one transaction' };
  }
  if (!values.vendor) {
    errors.vendor = 'You must select a vendor';
  }
  return errors;
};

export default validate;
